import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=a6ecb228&scoped=true"
import script from "./Comment.vue?vue&type=script&lang=js"
export * from "./Comment.vue?vue&type=script&lang=js"
import style0 from "./Comment.vue?vue&type=style&index=0&id=a6ecb228&prod&scoped=true&lang=scss"
import style1 from "./Comment.vue?vue&type=style&index=1&id=a6ecb228&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ecb228",
  null
  
)

export default component.exports